import { render, staticRenderFns } from "./rating-mark.vue?vue&type=template&id=dc164bd8"
import script from "./rating-mark.vue?vue&type=script&lang=ts"
export * from "./rating-mark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports